export class UserCosmetologist {
    public id?: number | null;
    public cosmetologist_id: number;
    public phone: string;
    public password: string;

    constructor() {
        this.cosmetologist_id = 0,
        this.phone = '';
        this.password = '';
    }
}
export const FormRules = {
    cosmetologist_id: [{ required: true }],
    phone: [{ required: true }],

    password: [
        { required: true, message: 'Please input Password', trigger: 'blur' },
        { min: 8, max: 16, message: 'Length should be 8 to 16', trigger: 'blur' },
    ],
};